module.exports = __webpack_public_path__ + "img/022.8def0921.jpg";